import { render, staticRenderFns } from "./OrderSources.vue?vue&type=template&id=50fefe8b&scoped=true"
import script from "./OrderSources.vue?vue&type=script&lang=js"
export * from "./OrderSources.vue?vue&type=script&lang=js"
import style0 from "./OrderSources.vue?vue&type=style&index=0&id=50fefe8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fefe8b",
  null
  
)

export default component.exports